import { createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/index";
import GoRules from "./pages/erp/gorules";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },

  {
    path: "/erp/gorules*",
    element: (
      <Layout>
        <GoRules />
      </Layout>
    ),
  },
]);
